import { TextAtlas } from "./TextAtlas";
import { TextTexture } from "./TextTexture";
import { Point } from "../../maths/Point";
import { RenderInfo } from "../../renders/RenderInfo";
import { FontInfo } from "../../utils/FontInfo";
import { WordText } from "../../utils/WordText";
import { CharRenderInfo } from "./CharRenderInfo";
import { CharRender_Canvas } from "./CharRender_Canvas";
import { MeasureFont } from "./MeasureFont";
import { EventDispatcher } from "../../events/EventDispatcher";
import { TextRenderConfig } from "./TextRenderConfig";
export class TextRender extends EventDispatcher {
    constructor() {
        super();
        this.mapFont = {};
        this.textAtlases = [];
        this.isoTextures = [];
        this.fontSizeInfo = {};
        this.fontID = 0;
        this.fontScaleX = 1.0;
        this.fontScaleY = 1.0;
        this._curStrPos = 0;
        this.lastFont = null;
        this.fontSizeW = 0;
        this.fontSizeH = 0;
        this.fontSizeOffX = 0;
        this.fontSizeOffY = 0;
        this.renderPerChar = true;
        this.charRender = new CharRender_Canvas(4096, 4096);
        this.fontMeasure = new MeasureFont(this.charRender);
    }
    getFontSizeInfo(font) {
        let finfo = this.fontSizeInfo[font];
        if (!finfo)
            this.fontSizeInfo[font] = finfo = this.fontMeasure.getFontSizeInfo(font, TextRenderConfig.standardFontSize);
        return finfo;
    }
    setFont(font) {
        if (this.lastFont == font)
            return;
        this.lastFont = font;
        var fontsz = this.getFontSizeInfo(font._family);
        var offx = fontsz >> 24;
        var offy = (fontsz >> 16) & 0xff;
        var fw = (fontsz >> 8) & 0xff;
        var fh = fontsz & 0xff;
        var k = font._size / TextRenderConfig.standardFontSize;
        this.fontSizeOffX = Math.ceil(offx * k);
        this.fontSizeOffY = Math.ceil(offy * k);
        this.fontSizeW = Math.ceil(fw * k);
        this.fontSizeH = Math.ceil(fh * k);
        if (font._font.indexOf('italic') >= 0) {
            this.fontStr = font._font.replace('italic', '');
        }
        else {
            this.fontStr = font._font;
        }
    }
    getNextChar(str) {
        var len = str.length;
        var start = this._curStrPos;
        if (!str.substring)
            return null;
        if (start >= len)
            return null;
        var i = start;
        var state = 0;
        for (; i < len; i++) {
            var c = str.charCodeAt(i);
            if ((c >>> 11) == 0x1b) {
                if (state == 1)
                    break;
                state = 1;
                i++;
            }
            else if (c === 0xfe0e || c === 0xfe0f) {
            }
            else if (c == 0x200d) {
                state = 2;
            }
            else {
                if (state == 0)
                    state = 1;
                else if (state == 1)
                    break;
                else if (state == 2) {
                }
            }
        }
        this._curStrPos = i;
        return str.substring(start, i);
    }
    filltext(runner, data, x, y, fontStr, color, strokeColor, lineWidth, textAlign) {
        if (data.length <= 0)
            return;
        var font = FontInfo.parse(fontStr);
        var nTextAlign = 0;
        switch (textAlign) {
            case 'center':
                nTextAlign = 1;
                break;
            case 'right':
                nTextAlign = 2;
                break;
        }
        this._fast_filltext(runner, data, x, y, font, color, strokeColor, lineWidth, nTextAlign);
    }
    _fast_filltext(runner, data, x, y, font, color, strokeColor, lineWidth, textAlign) {
        if (data && !(data.length >= 1))
            return;
        if (lineWidth < 0)
            lineWidth = 0;
        this.setFont(font);
        this.fontScaleX = this.fontScaleY = TextRenderConfig.fontScale;
        font._italic && (runner._italicDeg = 13);
        let wt = data;
        let isWT = data instanceof WordText;
        let str = data && data.toString();
        let sameTexData = isWT ? wt.pageChars : [];
        let strWidth = 0;
        if (isWT) {
            str = wt.text;
            strWidth = wt.width;
            if (strWidth < 0) {
                strWidth = wt.width = this.charRender.getWidth(this.fontStr, str);
            }
        }
        else {
            strWidth = str ? this.charRender.getWidth(this.fontStr, str) : 0;
        }
        switch (textAlign) {
            case 1:
                x -= strWidth / 2;
                break;
            case 2:
                x -= strWidth;
                break;
        }
        if (isWT) {
            if (this.hasFreedText(sameTexData) || wt.pagecharsCtx != runner) {
                sameTexData = wt.pageChars = [];
            }
        }
        let splitTex = this.renderPerChar = (!isWT) || TextRenderConfig.forceSplitRender || (isWT && wt.splitRender);
        if (!sameTexData || sameTexData.length < 1) {
            if (isWT) {
                wt.scalex = this.fontScaleX;
                wt.scaley = this.fontScaleY;
            }
            if (splitTex) {
                let stx = 0;
                let sty = 0;
                this._curStrPos = 0;
                let curstr;
                while (true) {
                    curstr = this.getNextChar(str);
                    if (!curstr)
                        break;
                    let ri = this.getCharRenderInfo(curstr, font, color, strokeColor, lineWidth, false);
                    if (!ri) {
                        break;
                    }
                    if (ri.isSpace) {
                    }
                    else {
                        var add = sameTexData[ri.texture.id];
                        if (!add) {
                            var o1 = { texgen: ri.texture.genID, tex: ri.texture, words: new Array() };
                            sameTexData[ri.texture.id] = o1;
                            add = o1.words;
                        }
                        else {
                            add = add.words;
                        }
                        add.push({ ri: ri, x: stx, y: sty, w: ri.bmpWidth / this.fontScaleX, h: ri.bmpHeight / this.fontScaleY });
                        stx += ri.width;
                    }
                }
            }
            else {
                let margin = (font._size / 3 | 0);
                let isotex = TextRenderConfig.noAtlas || (strWidth + margin + margin) * this.fontScaleX > TextRenderConfig.atlasWidth;
                let ri = this.getCharRenderInfo(str, font, color, strokeColor, lineWidth, isotex);
                sameTexData[0] = { texgen: ri.texture.genID, tex: ri.texture, words: [{ ri: ri, x: 0, y: 0, w: ri.bmpWidth / this.fontScaleX, h: ri.bmpHeight / this.fontScaleY }] };
            }
            isWT && (wt.pagecharsCtx = runner);
        }
        this._drawResortedWords(runner, x, y, sameTexData);
        runner._italicDeg = 0;
    }
    _drawResortedWords(runner, startx, starty, samePagesData) {
        var isLastRender = false;
        var mat = runner._curMat;
        for (var id in samePagesData) {
            var dt = samePagesData[id];
            if (!dt)
                continue;
            var pri = dt.words;
            var count = pri.length;
            if (count <= 0)
                continue;
            var tex = samePagesData[id].tex;
            for (var j = 0; j < count; j++) {
                var riSaved = pri[j];
                var ri = riSaved.ri;
                if (ri.isSpace)
                    continue;
                runner.touchRes(ri);
                runner.drawTexAlign = true;
                runner._inner_drawTexture(tex, tex.id, startx + riSaved.x - ri.orix, starty + riSaved.y - ri.oriy, riSaved.w, riSaved.h, mat, ri.uv, 1.0, isLastRender, 0xffffffff);
            }
        }
    }
    hasFreedText(txts) {
        for (let i in txts) {
            var pri = txts[i];
            if (!pri)
                continue;
            var tex = pri.tex;
            if (tex.destroyed || tex.genID != pri.texgen) {
                return true;
            }
        }
        return false;
    }
    getCharRenderInfo(str, font, color, strokeColor, lineWidth, isoTexture = false) {
        var fid = this.mapFont[font._family];
        if (fid == undefined) {
            this.mapFont[font._family] = fid = this.fontID++;
        }
        var key = str + '_' + fid + '_' + font._size + '_' + color;
        if (lineWidth > 0)
            key += '_' + strokeColor + lineWidth;
        if (font._bold)
            key += 'P';
        if (this.fontScaleX != 1 || this.fontScaleY != 1) {
            key += (this.fontScaleX * 20 | 0) + '_' + (this.fontScaleY * 20 | 0);
        }
        var sz = this.textAtlases.length;
        if (!isoTexture) {
            for (let i = 0; i < sz; i++) {
                ri = this.textAtlases[i].charMaps[key];
                atlas = this.textAtlases[i];
                if (ri) {
                    return ri;
                }
            }
        }
        var ri;
        var atlas;
        ri = new CharRenderInfo();
        let charRender = this.charRender;
        charRender.scale(this.fontScaleX, this.fontScaleY);
        ri.char = str;
        ri.height = font._size;
        var margin = (font._size / 3 | 0);
        if (!lineWidth) {
            lineWidth = 0;
        }
        var w1 = Math.ceil((charRender.getWidth(this.fontStr, str) + 2 * lineWidth) * this.fontScaleX);
        let needCanvW = Math.min(TextRenderConfig.maxCanvasWidth, w1 + margin * 2 * this.fontScaleX);
        if (needCanvW > charRender.canvasWidth) {
            charRender.canvasWidth = needCanvW;
        }
        if (isoTexture) {
            charRender.fontsz = font._size;
            let tex;
            let imgdt;
            if (TextRenderConfig.useImageData)
                imgdt = charRender.getCharBmp(str, this.fontStr, lineWidth, color, strokeColor, ri, margin, margin, margin, margin);
            else
                imgdt = charRender.getCharCanvas(str, this.fontStr, lineWidth, color, strokeColor, ri, margin, margin, margin, margin);
            tex = TextTexture.getTextTexture(imgdt.width, imgdt.height);
            tex.addChar(imgdt, 0, 0, ri.uv);
            ri.texture = tex;
            ri.orix = margin;
            ri.oriy = margin;
            tex.ri = ri;
            this.isoTextures.push(tex);
        }
        else {
            var len = str.length;
            if (len > 1) {
            }
            var lineExt = lineWidth * 1;
            var fw = Math.ceil((this.fontSizeW + lineExt * 2) * this.fontScaleX);
            var fh = Math.ceil((this.fontSizeH + lineExt * 2) * this.fontScaleY);
            imgdtRect[0] = ((margin - this.fontSizeOffX - lineExt) * this.fontScaleX) | 0;
            imgdtRect[1] = ((margin - this.fontSizeOffY - lineExt) * this.fontScaleY) | 0;
            if (this.renderPerChar || len == 1) {
                imgdtRect[2] = Math.max(w1, fw);
                imgdtRect[3] = Math.max(w1, fh);
            }
            else {
                imgdtRect[2] = -(this.fontSizeOffX * this.fontScaleX);
                imgdtRect[3] = fh;
            }
            this.charRender.fontsz = font._size;
            let imgdt;
            if (TextRenderConfig.useImageData)
                imgdt = this.charRender.getCharBmp(str, this.fontStr, lineWidth, color, strokeColor, ri, margin, margin, margin, margin, imgdtRect);
            else
                imgdt = this.charRender.getCharCanvas(str, this.fontStr, lineWidth, color, strokeColor, ri, margin, margin, margin, margin);
            if (imgdt.width > TextRenderConfig.atlasWidth || imgdt.height > TextRenderConfig.atlasWidth) {
                var tex = TextTexture.getTextTexture(imgdt.width, imgdt.height);
                tex.addChar(imgdt, 0, 0, ri.uv);
                ri.texture = tex;
                ri.orix = margin;
                ri.oriy = margin;
                tex.ri = ri;
                this.isoTextures.push(tex);
            }
            else {
                atlas = this.findAtlas(imgdt.width, imgdt.height);
                atlas.texture.addChar(imgdt, tmpAtlasPos.x, tmpAtlasPos.y, ri.uv);
                ri.texture = atlas.texture;
                if (!TextRenderConfig.useImageData) {
                    ri.orix = margin;
                    ri.oriy = margin;
                }
                else {
                    ri.orix = (this.fontSizeOffX + lineExt);
                    ri.oriy = (this.fontSizeOffY + lineExt);
                }
                atlas.charMaps[key] = ri;
            }
        }
        return ri;
    }
    findAtlas(w, h) {
        var sz = this.textAtlases.length;
        var atlas;
        var find = false;
        for (var i = 0; i < sz; i++) {
            atlas = this.textAtlases[i];
            find = atlas.getAEmpty(w, h, tmpAtlasPos);
            if (find) {
                break;
            }
        }
        if (!find) {
            atlas = new TextAtlas();
            this.textAtlases.push(atlas);
            find = atlas.getAEmpty(w, h, tmpAtlasPos);
            if (!find) {
                throw 'err1';
            }
            this.cleanAtlases();
        }
        return atlas;
    }
    GC() {
        var i = 0;
        var sz = this.textAtlases.length;
        var dt = 0;
        var destroyDt = TextRenderConfig.destroyAtlasDt;
        var totalUsedRateAtlas = 0;
        var curloop = RenderInfo.loopCount;
        var maxWasteRateID = -1;
        var maxWasteRate = 0;
        var tex = null;
        var curatlas = null;
        for (; i < sz; i++) {
            curatlas = this.textAtlases[i];
            tex = curatlas.texture;
            if (tex) {
                curatlas.updateTextureUsage();
                totalUsedRateAtlas += tex.curUsedCovRateAtlas;
                var waste = curatlas.usedRate - tex.curUsedCovRateAtlas;
                if (maxWasteRate < waste) {
                    maxWasteRate = waste;
                    maxWasteRateID = i;
                }
            }
            dt = curloop - curatlas.texture.lastTouchTm;
            if (dt > destroyDt) {
                TextRenderConfig.showLog && console.log('TextRender GC delete atlas ' + (tex ? curatlas.texture.id : 'unk'));
                curatlas.destroy();
                this.textAtlases[i] = this.textAtlases[sz - 1];
                sz--;
                i--;
                maxWasteRateID = -1;
            }
        }
        this.textAtlases.length = sz;
        var needGC = this.textAtlases.length > 1 && this.textAtlases.length - totalUsedRateAtlas >= 2;
        if (TextRenderConfig.atlasWidth * TextRenderConfig.atlasWidth * 4 * this.textAtlases.length > TextRenderConfig.cleanMem || needGC || TextRenderConfig.simClean) {
            TextRenderConfig.simClean = false;
            TextRenderConfig.showLog && console.log('清理使用率低的贴图。总使用率:', totalUsedRateAtlas, ':', this.textAtlases.length, '最差贴图:' + maxWasteRateID);
            if (maxWasteRateID >= 0) {
                curatlas = this.textAtlases[maxWasteRateID];
                curatlas.destroy();
                this.textAtlases[maxWasteRateID] = this.textAtlases[this.textAtlases.length - 1];
                this.textAtlases.length = this.textAtlases.length - 1;
                this.event('GC');
            }
        }
    }
    cleanAtlases() {
    }
}
const tmpAtlasPos = new Point();
const imgdtRect = [0, 0, 0, 0];
